import AutoHiddingNavAction from './actions/AutoHiddingNavAction'
import BookingComponent from './components/BookingComponent'
import HeaderComponent from './components/HeaderComponent'
import MenuComponent from './components/MenuComponent'
/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        05/01/2022 07:57
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */
import UtilsComponent from './components/UtilsComponent'

document.addEventListener('DOMContentLoaded', () => {
    new UtilsComponent()
    new MenuComponent()
    new HeaderComponent()
    new BookingComponent()
    new AutoHiddingNavAction()

    if ($('.home').length > 0) {
        ;(async () => {
            const { default: FrontPageComponent } = await import(
                './components/FrontPageComponent.js'
            )
            new FrontPageComponent()
        })().catch((error) => {
            // Handle/report error
            console.error(error)
        })
    }
})
